import { makeCrudStateReducer } from "seneca-common/utils/apiStates";

import { classSkeletonsCrudStateConfig } from "../../../../consts";

const classSkeletonsMetaReducer = makeCrudStateReducer(
  classSkeletonsCrudStateConfig
);
export default classSkeletonsMetaReducer;
